module.exports = __webpack_public_path__ + "static/media/Acheive5.7c6c0c0e.jpg";